import { useState } from "react";
import {
  FaStar,
  FaLeaf,
  FaHeart,
  FaRegHeart,
  FaPlus,
  FaMinus,
} from "react-icons/fa";

import { useCart } from "../../../context/CartContext";
import API from "../../../services/api";
import getImageUrl from "../../../utils/imageUrl";
import "./ProviderFoodCard.css";

export default function ProviderFoodCard({ food }) {

  // ==========================================
  // Cart Context
  // ==========================================

  const {
    addToCart,
    increaseQuantity,
    decreaseQuantity,
    getFoodQuantity,
  } = useCart();

  // ==========================================
  // Favorite
  // ==========================================

  const [favorite, setFavorite] = useState(
    food.isFavorite || false
  );

  // ==========================================
  // Quantity
  // ==========================================

  const quantity = getFoodQuantity(food.id);

  // ==========================================
  // Price
  // ==========================================

  const hasOffer = food.offerPrice > 0;

  const sellingPrice = hasOffer
    ? food.offerPrice
    : food.price;

  // ==========================================
  // Favorite Toggle
  // ==========================================

  const toggleFavorite = async () => {
    try {
      const res = await API.post(
        `/favorites/${food.id}`
      );

      setFavorite(res.data.favorite);

    } catch (error) {
      console.log(error);
    }
  };

  // ==========================================
  // JSX
  // ==========================================

  return (

    <div className="provider-food-card">

      {/* Favorite */}

      <button
        className="favorite-btn"
        onClick={toggleFavorite}
      >
        {favorite ? (
          <FaHeart className="filled-heart" />
        ) : (
          <FaRegHeart />
        )}
      </button>

      {/* Image */}

      <div className="provider-food-image">

       <img
  src={getImageUrl(food.image) || "/images/default-food.jpg"}
  alt={food.name || "Food"}
  onError={(e) => {
    e.currentTarget.src = "/images/default-food.jpg";
  }}
/>

        {food.isBestSeller && (
          <span className="badge best">
            ⭐ Best Seller
          </span>
        )}

        {food.isTodaysSpecial && (
          <span className="badge special">
            🔥 Today's Special
          </span>
        )}

        {!food.isAvailable && (
          <div className="out-of-stock">
            Out of Stock
          </div>
        )}

      </div>

      <div className="provider-food-content">

        <div className="food-top-row">

          <h3>{food.name}</h3>

          <span
            className={
              food.foodType === "Veg"
                ? "veg"
                : "nonveg"
            }
          >
            <FaLeaf />
          </span>

        </div>

        <p className="food-category">
          {food.category}
        </p>

        <div className="food-rating">
          <FaStar />
          <span>{food.rating || 4.5}</span>
        </div>

        <div className="food-bottom">

          <div className="food-price">

            <span className="price">
              ₹{sellingPrice}
            </span>

            {hasOffer && (
              <span className="old-price">
                ₹{food.price}
              </span>
            )}

          </div>

          {food.isAvailable && (

            quantity === 0 ? (

              <button
                className="add-btn"
                onClick={() => addToCart(food.id)}
              >
                <FaPlus />
                Add
              </button>

            ) : (

              <div className="quantity-box">

                <button
                  className="qty-btn"
                  onClick={() =>
                    decreaseQuantity(food.id)
                  }
                >
                  <FaMinus />
                </button>

                <span className="qty-count">
                  {quantity}
                </span>

                <button
                  className="qty-btn"
                  onClick={() =>
                    increaseQuantity(food.id)
                  }
                >
                  <FaPlus />
                </button>

              </div>

            )

          )}

        </div>

      </div>

    </div>

  );

}